import { serviceRouteConstants } from "@/Constants/routingConstants";

import { post } from ".";

export const _fetchCandidatesForProposeCandidate = async (data) => {
  // const user = store.getState().clientProfile.user;
  // const session = store.getState()?.session?.session;

  const request = {
    endPoint: serviceRouteConstants?.fetchCandidatesForProposeCandidate,
    data,
  };
  return await post(request);
};

// getContractShiftData

export const _getContractShiftDataForProposeCandidate = async (data) => {
  const request = {
    endPoint: serviceRouteConstants?.getContractShiftData,
    data,
  };
  return await post(request);
};
